import React, { useEffect, useRef, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';

const BackgroundMusic = ({ audioUrl, inline = false }) => {
  const audioRef = useRef(null);
  const [isMuted, setIsMuted] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const playPromise = audio.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => setIsPlaying(true))
        .catch(() => setIsPlaying(false));
    }

    return () => { if (audio) audio.pause(); };
  }, []);

  const toggleMute = () => {
    if (audioRef.current) {
      audioRef.current.muted = !audioRef.current.muted;
      setIsMuted(!isMuted);
      if (!isPlaying) {
        audioRef.current.play()
          .then(() => setIsPlaying(true))
          .catch(err => console.log('Play failed:', err));
      }
    }
  };

  if (!audioUrl) return null;

  return (
    <>
      <audio ref={audioRef} src={audioUrl} loop autoPlay muted={isMuted} preload="auto" />
      <button
        onClick={toggleMute}
        className={inline
          ? "text-white/60 hover:text-white transition p-1.5 rounded-lg hover:bg-white/10"
          : "fixed left-6 z-50 bg-[#0d6571] hover:bg-[#0d6571]/90 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110"
        }
        style={inline ? {} : { bottom: '24px' }}
        title={isMuted ? 'Unmute music' : 'Mute music'}
        data-testid="mute-toggle-btn"
      >
        {isMuted ? (
          <VolumeX className={inline ? "w-4 h-4" : "w-6 h-6"} />
        ) : (
          <Volume2 className={inline ? "w-4 h-4" : "w-6 h-6"} />
        )}
      </button>
    </>
  );
};

export default BackgroundMusic;
